(function () {
  'use strict';

  var configElement = document.getElementById('MuldPartiallyConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  var scriptPromise;
  var refreshTimer;

  function loadPartially() {
    if (window.PartiallyButton) return Promise.resolve();
    if (scriptPromise) return scriptPromise;

    scriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-muld-partially-library]');
      var script = existing || document.createElement('script');

      function ready() {
        if (window.PartiallyButton) resolve();
        else reject(new Error('Partial.ly checkout button did not load.'));
      }

      script.addEventListener('load', ready, { once: true });
      script.addEventListener('error', reject, { once: true });

      if (!existing) {
        script.src = config.scriptUrl;
        script.async = true;
        script.setAttribute('data-muld-partially-library', 'true');
        document.head.appendChild(script);
      }
    });

    return scriptPromise;
  }

  function checkoutButtons() {
    return Array.prototype.filter.call(
      document.querySelectorAll('button[name="checkout"]'),
      function (button) {
        return !button.closest('[data-muld-partially-plans]');
      }
    );
  }

  function ensurePlanContainers() {
    checkoutButtons().forEach(function (button) {
      var previous = button.previousElementSibling;
      if (previous && previous.hasAttribute('data-muld-partially-plans')) return;

      var container = document.createElement('section');
      container.className = 'muld-partially';
      container.hidden = true;
      container.setAttribute('data-muld-partially-plans', '');
      container.setAttribute('aria-label', 'Partial.ly payment plans');
      button.parentNode.insertBefore(container, button);
    });
  }

  function buttonConfig(offer, selector, cart) {
    return {
      offer: offer.id,
      returnUrl: config.cartUrl,
      returnConfirmedUrl: config.confirmedUrl,
      cssButton: true,
      cssButtonText: offer.label,
      cssButtonShowLogo: true,
      cssButtonLogoType: 'glyph',
      cssButtonLogoPlacement: 'after',
      cssButtonCustomBg: '#1c1a18',
      renderSelector: selector,
      shopifyCart: cart
    };
  }

  function renderPlans(container, market, cart, containerIndex) {
    var signature = [config.country, config.currency, cart.total_price, cart.item_count].join('|');
    if (container.getAttribute('data-signature') === signature) return Promise.resolve();

    container.setAttribute('data-signature', signature);
    container.hidden = false;
    container.innerHTML = '';

    var heading = document.createElement('h2');
    heading.className = 'muld-partially__heading';
    heading.textContent = 'Pay over time with Partial.ly';

    var lead = document.createElement('p');
    lead.className = 'muld-partially__lead';
    lead.textContent = market.lead;

    var choices = document.createElement('div');
    choices.className = 'muld-partially__choices';

    container.appendChild(heading);
    container.appendChild(lead);
    container.appendChild(choices);

    var targets = market.offers.map(function (offer, offerIndex) {
      var target = document.createElement('div');
      var targetId = 'MuldPartiallyButton-' + containerIndex + '-' + offerIndex;
      target.id = targetId;
      target.className = 'muld-partially__button';
      choices.appendChild(target);
      return { offer: offer, selector: '#' + targetId };
    });

    var terms = document.createElement('p');
    terms.className = 'muld-partially__terms';
    terms.textContent = 'No interest or MULD payment-plan fees. Shipping is charged with the initial payment.';
    container.appendChild(terms);

    return loadPartially().then(function () {
      targets.forEach(function (target) {
        var partiallyButton = new window.PartiallyButton(buttonConfig(target.offer, target.selector, cart));
        partiallyButton.init();
      });
    }).catch(function () {
      container.hidden = true;
      container.removeAttribute('data-signature');
    });
  }

  function hidePlans(container) {
    container.hidden = true;
    container.innerHTML = '';
    container.removeAttribute('data-signature');
  }

  function refresh() {
    ensurePlanContainers();

    var containers = document.querySelectorAll('[data-muld-partially-plans]');
    if (!containers.length) return;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart.');
        return response.json();
      })
      .then(function (cart) {
        var market = config.markets[config.country];
        var currency = cart.currency || config.currency;
        var eligible = market && currency === market.currency && cart.total_price >= market.minimum;

        Array.prototype.forEach.call(containers, function (container, index) {
          if (eligible) renderPlans(container, market, cart, index);
          else hidePlans(container);
        });
      })
      .catch(function () {
        Array.prototype.forEach.call(containers, hidePlans);
      });
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 80);
  }

  scheduleRefresh();

  var cartContainer = document.getElementById('CartContainer');
  if (cartContainer && window.MutationObserver) {
    new MutationObserver(scheduleRefresh).observe(cartContainer, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('shopify:section:load', scheduleRefresh);
}());
